export const STORAGE_KEYS = {
  SEEN_ONBOARDING: 'pc_seen_onboarding',
  PATIENT_TREATMENT: 'pc_patient_treatment',
  LANGUAGE: 'pc_language',
  HASH: 'pc_hash',
  REVIEW: 'pc_review',
} as const;

export const API_ENDPOINTS = {
  TREATMENT: '/treatment',
  RATING: '/rating',
  PACKAGES: '/packages',
  LOG: '/log',
} as const;

export const DEFAULT_LANGUAGE = 'fr';
export const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;
